import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { avatarColorClass } from '@shared/utils/avatar-color';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AvatarComponent implements OnChanges {

  @Input() name: string = "";
  @Input() tooltip:string = "";
  @Input() tooltipPosition:any = "right";
  @Input() showTooltip:boolean = true;
  @Input() badge:string = "";
  @Input() badgeColor:string = "accent";
  @Input() size:string = "";
  @Input() icon:string = "";
  // Optional explicit background (e.g. a branch color); falls back to the generated color class when empty.
  @Input() background:string = "";
  @Input() image: string | ArrayBuffer | null = "";
  public initials:string = "";
  public avatarClass = "";


  constructor() { }

  ngOnChanges(): void {

    if(this.icon){
      switch(this.icon){
        case 'folder':
        this.avatarClass = "disable";
        break;
        default:
        this.avatarClass = "clean";
        break;
      }

    }else{
    this.name = this.name??"".trim();
    if(this.name){
      // Skip separator-only tokens (e.g. the "-" in "Voka - Kamer van Koophandel") so the initials
      // read as "VK", not "V-". A token counts only if it contains a letter or digit.
      let nameArray = this.name.split(" ").filter(x => /[\p{L}\p{N}]/u.test(x));
      if(nameArray.length){
        this.initials = nameArray.length == 1 ? nameArray[0].substring(0,2) : nameArray[0].substring(0,1) + nameArray[1].substring(0,1);
      }else{
        this.initials = this.name.substring(0,2);
      }
    }
    if(!this.tooltip && this.showTooltip){
      this.tooltip = this.name;
    }

      this.avatarClass = avatarColorClass(this.name);
    }
  }
}
